<template>
  <div class="reactive-gift-choice--content" v-if="shouldGiftChoiceBlockBeDisplayed">
    <div class="reactive-gift-choice--content-header">
      <div class="reactive-gift-choice--content-header-wrapper">
        <h2 class="col-xs-12 reactive-gift-choice--content-header-title">{{
            t('gift.selection', { namespace: 'giftSelection' }) }}</h2>
      </div>
    </div>
    <div class="reactive-gift-choice--content-body">
      <adv-cart-gift-list :enable-picker="true"
                          :styling-options="stylingOptions"
                          :gift-choices-filter="filterGiftsWithChoice"></adv-cart-gift-list>
    </div>
  </div>
</template>

<script>
import AdvCartGiftList from './AdvCartGiftList'
import giftChoiceMixin from './mixins/giftChoiceMixin'
export default {
  name: 'AdvGiftChoiceBlock',
  data () {
    return {
      stylingOptions: {
        group: 'gift_user_choice__group choice_block col-xs-12',
        groupRow: 'gift_user_choice__group_row choice_block',
        items: 'gift_user_choice__items col-xs-12 col-md-6',
        groupBlock: 'gift_user_choice__group_block choice_block col-xs-12 col-lg-4 col-md-5',
        itemsBlock: 'gift_user_choice__items_block choice_block col-xs-12 advGiftRow',
        groupBlockThumbnailBlock: 'gift_user_choice__group_block_thumbnail_block choice_block col-xs-2 col-md-12',
        groupBlockThumbnail: 'gift_user_choice__group_block_thumbnail choice_block',
        groupBlockDescription: 'gift_user_choice__group_block_description choice_block col-xs-10 col-md-12',
        hint: 'gift_user_choice__hint choice_block col-xs-12'
      }
    }
  },
  components: {
    AdvCartGiftList
  },
  mixins: [giftChoiceMixin]
}
</script>
